$(document).ready(function() {

  $(document).on('mouseenter','.fot-product-card .product-related.select-color .item',function(){
    var parent = $(this).closest('.product-related.select-color');
    $(this).addClass('focus');
    parent.addClass('focus');
  })

  $(document).on('mouseleave','.fot-product-card .product-related.select-color .item',function(){
    var parent = $(this).closest('.product-related.select-color');
    $(this).removeClass('focus');
    parent.removeClass('focus');
  })

  $(document).on('click','.fot-product-card .product-related.select-color .item',function(){
    var parent = $(this).closest('.fot-product-card');
    $(this).addClass('active');
    parent.find('.item').not($(this)).removeClass('active');
    parent.find('.fot-product-card__title a').text($(this).data('name'));
    parent.find('.fot-product-link').attr('href',$(this).data('url'));
    parent.find('.fot-product-link .first-image').attr('src',$(this).data('imageFisrt'));
    parent.find('.fot-product-link .second-image').attr('src',$(this).data('imageSecond'));
    if($(this).data('priceSale') != undefined){
      parent.find('.price.price--listing').addClass('price--on-sale');
      parent.find('.price.price--listing .price__sale .price-item.price-item--sale').text($(this).data('price'));
      parent.find('.price.price--listing .price__sale .price__compare .price-item.price-item--regular').text($(this).data('priceSale'));
    }else{
      if(parent.find('.price.price--listing').hasClass('price--on-sale'))
      {
        parent.find('.price.price--listing').removeClass('price--on-sale');
      }
      parent.find('.fot-product-cart-bottom .price.price--listing .price__regular .price-item.price-item--regular').text($(this).data('price'));
    }
    if($(this).attr('product-tag') != undefined){
      parent.find('.fot-product-label').removeClass('hidden');
    }else{
      parent.find('.fot-product-label').addClass('hidden');
    }
    if($(this).data('arriving') != undefined){
      parent.find('.product-arriving').removeClass('hidden');
    }else{
      parent.find('.product-arriving').addClass('hidden');
    }
  })
});

jQuery(document).ready(function ($) {
    /* Add active when element has focus */
    //checkbox
    var input_selector = 'input[type=checkbox], input[type=radio]';
    $(input_selector).each(function () {
        selectId = $(this).attr('id')
        $('label[for="' + selectId + '"]').addClass('checkbox_radio');
    });
    //select
    var selectId = $("select").each(function () {
        selectId = $(this).attr('id')
        $('label[for="' + selectId + '"]').addClass('active');
        $('label[for="' + selectId + '"]').addClass('focusing');
    });
    //input
    function updateTextFields(input_selector) {
        setTimeout(function () {
            $(input_selector).each(function (index, element) {
                var $this = $(this);
                var inputId = $this.attr('id');
                if ($(element).val().length > 0 || $(element).is(':focus') || element.autofocus) {
                    $('label[for="' + inputId + '"]').addClass('active');
                } else if ($(element)[0].validity.badInput) {
                    $('label[for="' + inputId + '"]').toggleClass('active', $(element)[0].validity.badInput === true);
                } else {
                    $('label[for="' + inputId + '"]').removeClass('active');
                }
                if ($(element).is(':focus')) {
                    $('label[for="' + inputId + '"]').addClass('focusing');
                } else {
                    $('label[for="' + inputId + '"]').removeClass('focusing');
                }
                if ($(element).is(':-webkit-autofill')) {
                    $('label[for="' + inputId + '"]').addClass('focusing');
                } else {
                    $('label[for="' + inputId + '"]').removeClass('focusing');
                }
            });
        }, 300)
    };
    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], textarea';
    updateTextFields(input_selector);
    $(document).on('change', input_selector, function () {
        var inputId = $(this).attr('id');
        if ($(this).val().length !== 0 || $(this).attr('placeholder') !== undefined) {
            $('label[for="' + inputId + '"]').addClass('active');
        }
    });
    $(document).on('focus', input_selector, function () {
        var inputId = $(this).attr('id');
        $('label[for="' + inputId + '"]').addClass('active');
        $('label[for="' + inputId + '"]').addClass('focusing');
        $(this).siblings('.prefix').addClass('active');
    });
    $(document).on('blur', input_selector, function () {
        var $inputElement = $(this);
        var selector = ".prefix";
        var inputId = $(this).attr('id');
        if ($inputElement.val().length === 0 && $inputElement[0].validity.badInput !== true && $inputElement.attr('placeholder') === undefined) {
            $('label[for="' + inputId + '"]').removeClass('active');
        }
        $('label[for="' + inputId + '"]').removeClass('focusing');
        $inputElement.siblings(selector).removeClass('active');
    });
    /* Sicky header only when scroll down not scroll up */
    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        var height = $('.header-main-top').height();
        var annount = $('.announcement-bar').height();
        if (st > annount) {
            $('.header-main-top').addClass('nav-up');
            $('#MainContent').css('padding-top', height);
          	$(".announcement-bar").css("height", "77.8px");


            setPositionMegamenu();
        } else {
            $('.header-main-top').removeClass('nav-up');
            $('#MainContent').css('padding-top', 0);
          	$(".announcement-bar").css("height", "auto");
            setPositionMegamenu();
        }
        lastScrollTop = st;
    });
    //our prices
    $('.our-prices .price-sidebar .tab-list .tab-item:first-child').addClass('active');
    $('.our-prices .price-right .tab-content .tab-item:first-child').addClass('active');
    $('.our-prices .price-sidebar .tab-list .tab-item[data-toggle=tab]').click(function(){
    $('.our-prices .price-sidebar .tab-list .tab-item').removeClass('active');
    $(this).addClass('active');
    $id = $(this).attr('id');
    $('.our-prices .price-right .tab-content .tab-item').removeClass('active');
    $('.our-prices .price-right .tab-content .tab-item[id="' + $id + '"]').addClass('active');
  })
        //faq
    $('.faq .price-sidebar .tab-list .tab-item:first-child').addClass('active');
    $('.faq .price-right .tab-content .tab-item:first-child').addClass('active');
    $('.faq .price-sidebar .tab-list .tab-item[data-toggle=tab]').click(function(){
    $('.faq .price-sidebar .tab-list .tab-item').removeClass('active');
    $(this).addClass('active');
    $id = $(this).attr('id');
    $('.faq .price-right .tab-content .tab-item').removeClass('active');
    $('.faq .price-right .tab-content .tab-item[id="' + $id + '"]').addClass('active');
    })

  //image contact
  $('.bottom-left').slick({
    slidesPerRow: 1,
  });
  //best sellers homepage
  if ($(window).width() > 767) {
    jQuery('.home-best-seller .fot-grid--view-items').not('.slick-initialized').slick({
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerPadding: '25px',
    });
  }
  jQuery(window).on('load resize', function() {
    setTimeout(function() {
      var width = jQuery(window).width();
      if (width < 767) {
        if($('.home-best-seller .fot-grid--view-items').hasClass('slick-initialized')) {
          jQuery('.home-best-seller .fot-grid--view-items').slick("unslick");
        }
      }
      if (width > 767) {
        jQuery('.home-best-seller .fot-grid--view-items').not('.slick-initialized').slick({
            dots: false,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            centerPadding: '25px',
        });
      }
    }, 300);
  });
  // megamenu fot
  var fotMegamenu = (function(){

    var selector = {
      toggleMenu:".js-mobile-nav-toggle",
      dom:'body',
      back:'.fot-back-menu'
    }

    function init() {
      _toggleMegamenu();
      _slideOutMobile();
      _backMenu();
      _togleOnTable();
    }

    function _toggleMegamenu() {
      $(selector.toggleMenu).on('click',function() {
        $(selector.dom).toggleClass('open-menu');
        $('.fot-megamenu').toggleClass('active');
        if($('.fot-megamenu').hasClass('active')) {
          $('.header-megamenu-inner').hasClass('slide-out') && $('.header-megamenu-inner').removeClass('slide-out');
          $('.megamenu-wrapper').hasClass('active') && $('.megamenu-wrapper').removeClass('active');
        }
      });
    }

    function _slideOutMobile() {
      $('.fot-megamenu-dropdown > a').on('click',function(evt) {
        if($(window).width() < 768) {
          evt.preventDefault();
          $(this).parent().find('.megamenu-wrapper').addClass('active');
          $('.header-megamenu-inner').addClass('slide-out');
        }
      });
    }

    function _togleOnTable() {
      $(document).mouseup(function(e) {
        if($(window).width() > 767 && $(window).width() < 1200) {
          var container = $('.header-megamenu-inner');

          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.megamenu-main-item.start').removeClass('start');
          }
        }
      });
      $('.megamenu-main-item.has-child > a').on('click',function(e) {
        if($(window).width() > 767 && $(window).width() < 1200) {
          if (!$(this).parent().hasClass('start')) {
            e.preventDefault();
            $(this).parent().addClass('start');
          }else {
            window.location.href = $(this).attr('href');
          }
        }
      })
    }

    function _backMenu() {
      $(selector.back).on('click',function() {
        setTimeout(function(){
          $(this).closest('.megamenu-wrapper').removeClass('active');
          $('.header-megamenu-inner').removeClass('slide-out');
        }.bind(this),0);
      });
    }
    return {
      init: init
    }
  })();

  fotMegamenu.init();
  // Dropdown footer
  let title = '[data-role="dropdown-title"]';
  let content = '[data-role="dropdown-content"]';
  $(title).click(function() {
      if ($(window).width() < 768) {
          if ($(this).hasClass('active')) {
              $(this).removeClass('active');
              $(this).next().hide(300);
          } else {
              $(title).removeClass('active');
              $(content).hide(300);
              $(this).addClass("active");
              $(this).next().show(300);
          }
      }
  });
  //page blog
  $('.fot-blog-articles.list .item > h3').on('click',function() {
    $(this).parent().toggleClass('active');
    if($(this).next().hasClass('active')) {
      $(this).next().slideUp(50).removeClass('active');
    }else {
      $(this).next().slideToggle(50).toggleClass('active');
    }
  });
  //page faq
  $('.mobile-faq .item > li').on('click',function() {
    $(this).parent().toggleClass('active');
    if($(this).next().hasClass('active')) {
      $(this).next().slideUp(50).removeClass('active');
    }else {
      $(this).next().slideToggle(50).toggleClass('active');
    }
  });





  //mailchimp
  function mailchimpResponse(message,status) {
    $('#mailchimp_form .message').removeClass('error success');
    $('#mailchimp_form .message').text(message);
    $('#mailchimp_form .message').addClass(status).show();
    setTimeout(function() {
      $('#mailchimp_form .message').hide().removeClass('error success');
    }, 6000);
  }
  var $form = $('#mailchimp_form');
  $form.on('submit',function() {
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(!reg.test($form.find('.input-group__field.newsletter__input').val())) {
      mailchimpResponse("This field is required.","error");
      return false;
    }
    $.ajax({
      type: 'GET',
      url: $form.attr('action').replace('/subscribe/post', '/subscribe/post-json'),
      data: $form.serialize(),
      dataType : 'jsonp',
      jsonp: 'c', // trigger MailChimp to return a JSONP response
      contentType: 'application/json; charset=utf-8',
      success: function(data){
        (data.result == 'success') && mailchimpResponse(data.msg,"success");
        (data.result == 'error') && mailchimpResponse("Email is already subscribed","error");
      }
    });
    return false;
  });
  //account page new prescription
  $('.template-customers-account .new-prescription-wrapper .btn-new-prescription').on('click', function(e) {
    e.preventDefault();
    $('body').toggleClass('open-new-prescription-form');
    $('.new-prescription-inner').toggleClass('show-inner');
    $('.account-prescription-wrapper .list-ct').toggleClass('hidden-list');
    $('.account-prescription-wrapper .btn-new-prescription').toggleClass('hidden-list');
    // scroll to top
    scrollToTopNewPrescription();
  });
  $('.template-customers-account .new-prescription-wrapper #prescription-form').on('submit', function(e) {
    if ($('#prescription-form #input-name').val() != '') {
      $('.new-prescription-wrapper #prescription-form .submit-prescription-wrapper').addClass('loading');
    }
  });
  // check duplicate prescription
  // $(document).on('click', '.template-customers-account #prescription-form .submit-check-duplicate-name', function(e) {
  //   e.preventDefault();
  //   if ($('.template-customers-account #prescription-form #input-name').val() == '') {
  //     $('.template-customers-account #prescription-form input[type="submit"]').trigger('click');
  //     scrollToTopNewPrescription();
  //   } else {
  //     // compare with current prescription list
  //     var name = $('.template-customers-account #prescription-form #input-name').val();
  //     var is_existed = false;
  //     $('.template-customers-account .account-prescription-wrapper .list-ct > li').each(function() {
  //       if (name.trim().toLowerCase() == $(this).data('prescription-name').trim().toLowerCase()) {
  //         is_existed = true;
  //       }
  //     });
  //     // submit
  //     if (is_existed) {
  //       alert('Name is already existed');
  //       scrollToTopNewPrescription();
  //       $('.template-customers-account #prescription-form #input-name').focus();
  //     } else {
  //       $('.template-customers-account #prescription-form input[type="submit"]').trigger('click');
  //     }
  //   }
  // });
  function scrollToTopNewPrescription() {
    if ($(document).scrollTop() > $('.new-prescription-wrapper .new-prescription-inner').offset().top) {
      var stickyHeaderHeight = 0;
      if ($('.header-main-top.nav-up').length) {
        stickyHeaderHeight = $('.header-main-top.nav-up').height();
      }
      var scrollTopVal = $('.new-prescription-wrapper .new-prescription-inner').offset().top;
      if (scrollTopVal >= stickyHeaderHeight) {
        scrollTopVal = scrollTopVal - stickyHeaderHeight;
      }
      $('html, body').animate({
        scrollTop: scrollTopVal
      }, 300);
    }
  }
  // my account sidebar
  if (window.location.href.indexOf('?view=') > 0 ) {
    urlParam = window.location.href.split('=');
    myItem = "." + urlParam[1];
    $('.account-main').find(".grid__item").removeClass("active");
    $('.account-main').find(myItem).addClass("active");
    $('.account-sidebar .list-tab .item-tab').removeClass('active');
    $('.account-sidebar .list-tab').find(myItem).addClass('active');
  }
  // close message
  $(document).on('click', '.close-message', function(e) {
    e.preventDefault();
    $(this).parent().remove();
  });

  //wow js
  new WOW().init();

  //megamenu
  function setPositionMegamenu() {
    let heightHeader = $('[data-section-id="header"]').height();
    if ($(window).width() < 768) {
      $('.fot-megamenu').css({"top": heightHeader, "height": "calc(100% - "+heightHeader+"px)"});
    }
  }

  setPositionMegamenu();
  $(window).on('resize', function() {
    setPositionMegamenu();
  });
  //home article
  if (window.location.href.indexOf('?blog=') > 0 ) {
    urlParam = window.location.href.split('=');
    myItem = urlParam[1];
    $('.fot-blog-articles .item').removeClass('active');
    $('.fot-blog-articles .item .content').removeClass('active');
    $('.fot-blog-articles').find("[data-handle='" + myItem + "']").addClass('active');
    $('.fot-blog-articles').find("[data-handle='" + myItem + "'] .content").addClass('active');
    var scroll_pos = $('.fot-blog-articles').find("[data-handle='" + myItem + "'] h3").offset().top - $('.fot-blog-articles').find("[data-handle='" + myItem + "'] h3").height() - $('#shopify-section-header .header-main-top').height();
    $(window).on('load', function() {
      $('html, body').animate({
        scrollTop: scroll_pos
      }, 500);
    });
  }
  jQuery("#PageContainer .faqSection li h4").click(function() {
      jQuery(this).toggleClass("active");
      jQuery(this).next().slideToggle();
  });
  // // redirect back to product page after login or create account
  // if (sessionStorage.getItem('checkpoint-product-url') && $('body.logged-in').length) {
  //   var productUrl = sessionStorage.getItem('checkpoint-product-url');
  //   sessionStorage.removeItem('checkpoint-product-url');
  //   sessionStorage.setItem('checkpoint-product-continue', true);
  //   window.location.href = productUrl;
  // }
});